
import React, { PropTypes } from 'react';

export class LogoInvoiceWithoutCompany extends React.Component {

  static propTypes = {
    colorSchema: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    classes: PropTypes.string
  };

  getFillColor () {
    switch (this.props.colorSchema) {
      case 'primary':
        return '#00587c';
      case 'green-profile':
        return '#53AD99';
      case 'white':
        return '#ffffff';
      default:
        return '#000000';
    }
  }

  render () {
    const fillColor = this.getFillColor();

    return (
      <svg
        version='1.1'
        id='Layer_1'
        xmlns='http://www.w3.org/2000/svg'
        x='0px'
        y='0px'
        viewBox='0 0 432.3 109.7'
      >
        <path d={'M0.1,101.4V78.1c0-0.3,0.1-0.6,0.3-0.8C0.6,77.1,0.9,77,1.1,77h11.3c0.2,0,0.4,0.1,' +
          '0.6,0.3c0.1,0.3,0.2,0.5,0.2,0.8v0.6c0,0.3,0,0.6-0.2,0.8c-0.1,0.2-0.3,0.3-0.6,0.3H3.2V88' +
          'h8.5c0.2,0,0.4,0.1,0.6,0.3c0.1,0.3,0.2,0.5,0.2,0.8v0.6c0,0.3,0,0.6-0.2,0.8c-0.1,0.2-0.3' +
          ',0.3-0.6,0.3H3.2v10.7c0,0.5-0.5,0.8-1.4,0.8H1.5C0.6,102.2,0.1,101.9,0.1,101.4z'}
          fill={fillColor}
        />
        <path d={'M18,100.9c-1.2-1-1.8-2.5-1.7-4c-0.1-1.6,0.5-3.2,1.7-4.2s2.6-1.6,4.2-1.8c2-0.3,4-0.4,' +
          '6-0.4v-1.7c0-0.8-0.3-1.6-0.9-2.2c-0.9-0.6-1.9-0.9-3-0.8c-0.9,0-1.9,0.1-2.8,0.4c-0.7,' +
          '0.2-1.3,0.5-2,0.8c-0.3,0.1-0.6,0.3-0.9,0.4c-0.2,0-0.5-0.2-0.8-0.7c-0.2-0.3-0.4-0.7-0.4-1' +
          '.1c0-0.3,0.3-0.6,0.9-1c0.8-0.4,1.6-0.7,2.5-0.9c1.1-0.3,2.2-0.4,3.3-0.4c1.8-0.1,3.7,0.4,5' +
          '.2,1.5c1.2,1,1.9,2.5,1.9,4.1v8c0,1.1,0,2.3,0.2,3.4c0.1,0.7,0.2,1.1,0.2,1.1c0,0.3-0.2,0.5' +
          '-0.7,0.6c-0.4,0.1-0.8,0.2-1.3,0.2c-0.3,0-0.6-0.2-0.7-0.6c-0.2-0.4-0.3-0.8-0.4-1.2c-0.1-0' +
          '.4-0.1-0.7-0.2-0.8c-1.5,1.7-3.7,2.7-6,2.7C20.9,102.4,19.3,101.9,18,100.9z M25.6,99c0.9-' +
          '0.5,1.8-1.1,2.6-1.8V93c-1.8,0-3.2,0.1-4.4,0.2c-1.1,0.1-2.1,0.4-3,1c-0.9,0.5-1.4,1.5-1.3,' +
          '2.5c-0.1,0.8,0.2,1.6,0.8,2.2c0.6,0.5,1.4,0.8,2.3,0.8C23.6,99.7,24.7,99.5,25.6,99z'}
          fill={fillColor}
        />
        <path d={'M51.4,101.7c0,0.2-0.1,0.3-0.4,0.4c-0.4,0.1-0.8,0.1-1.2,0.1h-0.1c-0.4,0-0.8,0-1.2-' +
          '0.1c-0.3,0-0.5-0.2-0.7-0.4l-7.2-8.5h-0.1v8.2c0,0.5-0.5,0.8-1.4,0.8H39c-1,0-1.4-0.3-1.4-' +
          '0.8V76c0-0.5,0.5-0.8,1.4-0.8l0,0c1,0,1.4,0.3,1.4,0.8v16h0.1l6.8-8.2c0.3-0.3,0.9-0.5,1.9-' +
          '0.5h0.1c0.3,0,0.6,0,0.9,0.1c0.2,0.1,0.3,0.2,0.3,0.3c0,0.3-0.2,0.5-0.4,0.7l-6.7,7.9l7.4,' +
          '8.7C51.2,101.2,51.4,101.4,51.4,101.7z'}
          fill={fillColor}
        />
        <path d={'M58,101.2c-0.9-0.7-1.4-2-1.4-3.8V85.9h-1.8c-0.2,' +
          '0-0.4-0.1-0.5-0.3c-0.1-0.3-0.2-0.5-0.2-0.8v-0.4c0-0.3,' +
          '0-0.6,0.2-0.8c0.1-0.2,0.3-0.3,0.5-0.3h1.8l0.4-3.8c0.1-0.5,' +
          '0.5-0.8,1.1-0.8h0.4c0.7,0,1.1,0.3,1.1,0.8v3.8h3c0.2,0,0.4,0.1,' +
          '0.6,0.3c0.1,0.3,0.2,0.5,0.2,0.8v0.4c0,0.3,0,0.6-0.2,0.8c-0.1,0.2-0.3,' +
          '0.3-0.6,0.3h-3V97c-0.1,0.7,0.1,1.5,0.5,2.1c0.4,0.4,0.9,0.6,1.4,0.6c0.3,' +
          '0,0.7,0,1-0.1c0.2-0.1,0.3-0.1,0.5-0.1s0.4,0.2,0.5,0.7c0.1,0.3,0.2,0.7,' +
          '0.2,1c0,0.7-0.9,1.1-2.6,1.1C60,102.3,58.9,101.9,58,101.2z'}
          fill={fillColor}
        />
        <path d={'M69.2,100.8c-1.1-1.1-1.6-2.7-1.6-4.3V84.1c0-0.5,0.5-0.8,1.4-0.8h0.1c1,0,1.4,0.3,1.4,' +
          '0.8v12.1c-0.1,0.9,0.3,1.9,0.9,2.6c0.7,0.6,1.7,1,2.7,0.9c0.9,0,1.7-0.2,2.4-0.7c0.8-0.5,1.5-1.1,' +
          '2.1-1.8V84.1c0-0.5,0.5-0.8,1.4-0.8h0.1c1,0,1.4,0.3,1.4,0.8v12.7c0,1.1,0,2.3,0.2,3.4c0.1,0.7,0.2,' +
          '1.1,0.2,1.1c0,0.3-0.2,0.5-0.7,0.6c-0.4,0.1-0.8,0.2-1.3,0.2c-0.3,0-0.6-0.2-0.7-0.6c-0.2-0.4-0.3-' +
          '0.8-0.4-1.2c-0.1-0.4-0.1-0.7-0.2-0.8c-0.7,0.8-1.6,1.5-2.6,2c-0.9,0.5-1.9,0.7-3,0.7C71.9,102.4,70.3,' +
          '101.8,69.2,100.8z'}
          fill={fillColor}
        />
        <path d={'M88.1,101.4V88.8c0-1.1,0-2.3-0.2-3.4c-0.1-0.7-0.2-1.1-0.2-1.1c0-0.3,0.2-0.5,' +
          '0.7-0.6c0.4-0.1, 0.8-0.2,1.3-0.2c0.3,0,0.6,0.2,0.7,0.5c0.2,0.4,0.3,0.7,0.4,1.1s0.1,' +
          '0.6,0.2,0.8c1.3-1.8,2.6-2.7,4.1-2.7c0.5,0,1.1,0.1,1.5,0.4c0.3,0.2,0.5,0.6,0.5,1s-0' +
          '.1,0.9-0.2,1.3s-0.3,0.7-0.5,0.7s-0.5-0.1-0.7-0.2c-0.4-0.1-0.8-0.2-1.3-0.2c-0.6,0-1.' +
          '1,0.2-1.6,0.5s-0.9,0.6-1.2,1.1c-0.2,0.2-0.4,0.4-0.5,0.6v13.1c0,0.5-0.5, 0.8-1.4,0.8' +
          'h-0.1C88.6,102.2,88.1,101.9,88.1,101.4z'}
          fill={fillColor}
        />
        <path d={'M102.1,100c-1.4-1.5-2.1-3.9-2.1-7.1s0.7-5.6,2.1-7.2c1.6-1.7,3.9-2.6,6.2-2.5' +
          'c2.1-0.1,4.2,0.7,5.5 ,2.4c1.2,1.6,1.9,3.9,1.9,7c-0.1,0.3-0.2,0.6-0.4,0.9c-0.3,0.' +
          '4-0.5,0.6-0.8,0.6h-11.3c0,1.6,0.5,3.1,1.5,4.4c1.1,1,2.5,1.5,4,1.4c0.9,0,1.8-0.1,2.' +
          '6-0.4c0.6-0.2,1.2-0.5,1.8-0.8c0.3-0.2,0.5-0.3,0.8-0.4c0.2,0,0.5,0.2 ,0.8,0.7c0.2,0.' +
          '3,0.4,0.7,0.4,1.1c0,0.3-0.3,0.6-0.9,1c-0.7,0.4-1.5,0.7-2.4,0.9c-1,0.3-2.1,0.4-3.2,0.4' +
          'C105.7,102.3,103.5,101.5,102.1,100z M112.4,91.4c0-3.8-1.4-5.7-4.3-5.7c-3.1,0-4.7,1.9-' +
          '5,5.7H112.4z'}
          fill={fillColor}
        />
        <path d={'M120.5,101.4V88.8c0-1.1,0-2.3-0.2-3.4c-0.1-0.7-0.2-1.1-0.2-1.1c0-0.3,0.2-0.5,0.7-0.' +
          '6c0.4-0.1, 0.8-0.2,1.3-0.2c0.3,0,0.6,0.2,0.7,0.5c0.2,0.4,0.3,0.7,0.4,1.1s0.1,0.6,0.2,0.8c1' +
          '.3-1.8,2.6-2.7,4.1-2.7c0.5,0,1.1,0.1,1.5,0.4c0.3,0.2,0.5,0.6,0.5,1s-0.1,0.9-0.2,1.3c-0.1' +
          ',0.4-0.3,0.7-0.5,0.7s-0.5-0.1-0.7-0.2c-0.4-0.1-0.8-0.2-1.3-0.2c-0.6,0-1.1,0.2-1.6,0.5s-0.9,0' +
          '.6-1.2,1.1c-0.2,0.2-0.4,0.4-0.5,0.6v13.1c0,0.5 -0.5,0.8-1.4,0.8H122C120.9,102.2,120.5,' +
          '101.9,120.5,101.4z'}
          fill={fillColor}
        />
        <path d={'M133.8,100.9c-1.2-1-1.8-2.5-1.7-4c-0.1-1.6,0.5-3.2,' +
          '1.7-4.2s2.6-1.6,4.2-1.8c2-0.3,4-0.4,' +
          '6-0.4v-1.7c0-0.8-0.3-1.6-0.9-2.2c-0.9-0.6-1.9-0.9-3-0.8c-0.9,' +
          '0-1.9,0.1-2.8,0.4c-0.7,' +
          '0.2-1.3,0.5-2,0.8c-0.3,0.1-0.6,0.3-0.9,' +
          '0.4c-0.2,0-0.5-0.2-0.8-0.7c-0.2-0.3-0.4-0.7-0.4-1.1c0-0.3,' +
          '0.3-0.6,0.9-1c0.8-0.4,1.6-0.7,2.5-0.9c1.1-0.3,2.2-0.4,3.3-0.4c1.8-0.1,3.7,0.4,' +
          '5.2,1.5c1.2,1,1.9,2.5,1.9,4.1v8c0,1.1,0,2.3,0.2,3.4c0.1,0.7,0.2,1.1,0.2,1.1c0,0.3-0.2,0.5-0.7,' +
          '0.6c-0.4,0.1-0.8,0.2-1.3,0.2c-0.3,' +
          '0-0.6-0.2-0.7-0.6c-0.2-0.4-0.3-0.8-0.4-1.2c-0.1-0.4-0.1-0.7-0.2-0.8c-1.5,' +
          '1.7-3.7,2.7-6,2.7C136.6,102.4,135,101.9,133.8,100.9z M141.4,99c0.9-0.5,' +
          '1.8-1.1,2.6-1.8V93c-1.8,0-3.2 ,0.1-4.4,0.2c-1.1,' +
          '0.1-2.1,0.4-3,1c-0.9,0.5-1.4,1.5-1.3,' +
          '2.5c-0.1,0.8,0.2,1.6,0.8,2.2c0.6,0.5,1.4,0.8,2.3,0.8C139.4,' +
          '99.7,140.4,99.5,141.4,99L141.4,99z'}
          fill={fillColor}
        />
        <path d={'M162.6,100.8c-1.1-1.1-1.6-2.7-1.6-4.3V84.1c0-0.5,0.5-0.8,1.4-0.8h0.1c1,0,1.4,0.3,1.' +
          '4,0.8v12.1c-0.1,0.9,0.3, 1.9,0.9,2.6c0.7,0.6,1.7,1,2.7,0.9c0.9,0,1.7-0.2,2.4-0.7c0.8-0.5,1' +
          '.5-1.1,2.1-1.8V84.1c0-0.5,0.5-0.8,1.4-0.8h0.1c1,0 ,1.4,0.3,1.4,0.8v12.7c0,1.1,0,2.3,0.2,3.4c0.1,0.7,0' +
          '.2,1.1,0.2,1.1c0,0.3-0.2,0.5-0.7,0.6c-0.4,0.1-0.8,0.2-1.3,0.2c-0.3,0-0.6-0.2-0.7-0.6c-0.2-0.' +
          '4-0.3-0.8-0.4-1.2c-0.1-0.4-0.1-0.7-0.2-0.8c-0.7,0.8-1.6,1.5-2.6,2c-0.9,0.5-1.9,0.7-3, 0.7C165.3,102' +
          '.4,163.8,101.8,162.6,100.8z'}
          fill={fillColor}
        />
        <path d={'M183.6,101.2c-0.9-0.7-1.4-2-1.4-3.8V85.9h-1.8c-0.2,' +
          '0-0.4-0.1-0.5-0.3c-0.1-0.3-0.2-0.5-0.2-0.8v-0.4c0-0.3,0-0.6,' +
          '0.2-0.8c0.1-0.2,0.3-0.3,0.5-0.3h1.8l0.4-3.8c0.1-0.5,0.5-0.8,' +
          '1.1-0.8h0.4c0.7,0,1.1,0.3,1.1,0.8v3.8h3c0.2,0,0.4,0.1,0.6,' +
          '0.3c0.1,0.3,0.2,0.5,0.2,0.8v0.4c0,0.3,0,0.6-0.2,0.8c-0.1,' +
          '0.2-0.3,0.3-0.6,0.3h-3V97c-0.1,0.7,0.1,1.5,0.5,2.1c0.4,0.4,' +
          '0.9,0.6,1.4,0.6c0.3,0,0.7,0,1-0.1c0.2,0,0.3-0.1,0.5-0.1s0.4,' +
          '0.2,0.5,0.7c0.1,0.3,0.2,0.7,0.2,1c0,0.7-0.9,1.1-2.6,1.1C185.6,' +
          '102.3,184.5,101.9,183.6,101.2z'}
          fill={fillColor}
        />
        <path d={'M194,100.9c-1.2-1-1.8-2.5-1.7-4c-0.1-1.6,0.5-3.2,1.7-4.2s2.6-1.6,' +
            '4.2-1.8c2-0.3,4-0.4,6-0.4v-1.7c0-0.8-0.3-1.6-0.9-2.2c-0.9-0.6-1.' +
            '9-0.9-3-0.8c-0.9,0-1.9,0.1-2.8,0.4c-0.7,0.2-1.3,0.5-2,0.8c-0.3,' +
            '0.1-0.6,0.3-0.9,0.4c-0.2,0-0.5-0.2-0.8-0.7c-0.2-0.3-0.4-0.7-0.4-1.' +
            '1c0-0.3,0.3-0.6,0.9-1c0.8-0.4,1.6-0.7,2.5-0.9c1.1-0.3,2.2-0.4,' +
            '3.3-0.4c1.8-0.1,3.7,0.4,5.2,1.5c1.2,1,1.9,2.5,1.9,4.1v8c0,' +
            '1.1,0,2.3,0.2,3.4c0.1,0.7,0.2,1.1,0.2,1.1c0,0.3-0.2,0.5-0.7,' +
            '0.6c-0.4,0.1-0.8,0.2-1.3,0.2c-0.3,0-0.6-0.2-0.7-0.6c-0.2-0.4-' +
            '0.3-0.8-0.4-1.2c-0.1-0.4-0.1-0.7-0.2-0.8c-1.5,1.7-3.7,2.7-6,' +
            '2.7C196.8,102.4,195.3,101.9,194,100.9z M201.6,99c0.9-0.5,' +
            '1.8-1.1,2.6-1.8V93c-1.8,0-3.2,0.1-4.4,0.2c-1.1,0.1-2.1,' +
            '0.4-3,1c-0.9,0.5-1.4,1.5-1.3,2.5c-0.1,0.8,0.2,1.6,0.8,' +
            '2.2c0.6,0.5,1.4,0.8,2.3,0.8C199.6,99.7,200.6,99.5,201.6,' +
            '99L201.6,99z'}
          fill={fillColor}
        />
        <path d={'M213.1,101.4V88.8c0-1.1,0-2.3-0.2-3.4c-0.1-0.7-0.2-1.1-0.2-1.1c0-0.3,0.2-0.5,0.7-0.' +
          '6c0.4-0.1,0.8-0.2,1.3-0.2c0.3, 0,0.6,0.2,0.7,0.5c0.2,0.4,0.3,0.7,0.4,1.1c0.1,0.4,0.1,0.6' +
          ',0.2,0.8c0.7-0.8,1.6-1.5,2.6-2c0.9-0.5,1.9-0.7,3-0.7c1.6-0.1,3.1,0.5,4.3,1.5c1.1,1.1,1.6,2' +
          '.7,1.6,4.3v12.4c0,0.5-0.5,0.8-1.4,0.8H226c-1,0-1.4-0.3-1.4-0.8V89.2c0.1-0.9-0.3-1.9-0.9-2.6c-' +
          '0.7-0.6-1.7-1-2.7-0.9c-0.9,0-1.7,0.2-2.4,0.7c-0.8,0.5-1.5,1.1-2.1,1.8v13.1c0,0.5-0.5,0.8-1.' +
          '4,0.8H215C213.6,102.2,213.1, 101.9,213.1,101.4z'}
          fill={fillColor}
        />
        <path d={'M242.7,100c-1.4-1.5-2.1-3.9-2.1-7.1s0.7-5.6,2.1-7.2c1.6-1.7,3.9-2.6,6.2-2.5c2.1-0.1' +
          ',4.2,0.7,5.5,2.4c1.2,1.6,1.9, 3.9,1.9,7c-0.1,0.3-0.2,0.6-0.4,0.9c-0.3,0.4-0.5,0.6-0.8' +
          ',0.6h-11.3c0,1.6,0.5,3.1,1.5,4.4c1.1,1,2.5,1.5,4,1.4c0.9,0,1.8-0.1,2.6-0.4c0.6-0.2,1.2-0.5,1.8' +
          '-0.8c0.3-0.2,0.5-0.3,0.8-0.4c0.2,0,0.5,0.2,0.8,0.7c0.2,0.3,0.4,0.7,0.4,1.1c0,0.3-0.3,0.6-0.9' +
          ',1c-0.7,0.4-1.5,0.7-2.4,0.9c-1,0.3-2.1,0.4-3.2,0.4C246.3,102.3,244.1,101.5,242.7,100z M253,91.4c' +
          '0-3.8-1.4-5.7-4.3-5.7c -3.1,0-4.7,1.9-5,5.7H253z'}
          fill={fillColor}
        />
        <path d={'M261.5,108.6c-1.3-0.6-2.1-1.9-2-3.4c0-1,0.3-1.9,0.9-2.7c0.6-0.8,1.4-1.4,2.4-1.8v-0.' +
          '1c-0.9-0.7-1.5-1.8-1.4-2.9c0-1.5,0.7-2.9,2-3.7c-0.9-0.5-1.7-1.2-2.3-2.1c-0.5-0.9-0.8-1' +
          '.9-0.8-3c0-1.6,0.6-3.1,1.9-4.2c1.5-1.2,3.3-1.8 ,5.2-1.6c0.7,0,1.4,0.1,2.1,0.2h6.5c0.2,0,0.4,0.1' +
          ',0.6,0.3c0.1,0.3,0.2,0.5,0.2,0.8v0.4c0,0.3,0,0.6-0.2,0.8c-0.1,0.2-0.3,0.3-0.6,0.3c-0.8,0-1.7' +
          ',0-2.5-0.1v0.1c0.6,0.9,1,2,0.9,3.1c0,1.6-0.6,3.2-1.8,4.2c-1.5,1.2-3.3,1.8-5.2,1.6c-0.9-0.1-1.8,0.1-' +
          '2.5,0.6c-0.6,0.4-0.9,1.1-0.9,1.9c0,0.5,0.2,1.1,0.6,1.4s0.9,0.6,1.5,0.7c0.8,0.2,1.7,0.3,2.5,0.4 c0.5' +
          ',0,0.9,0.1,1.2,0.1c1.4,0.1,2.8,0.5,4,1.2c1,0.7,1.5,1.9,1.4,3.1c0.1,1.6-0.7,3.1-2.1,4c-1.8,1-4,' +
          '1.5-6.1,1.4C265,109.8,263.1,109.4,261.5,108.6z M271,106.6c0.8-0.4,1.2-1.2,1.2-2s-0.4-1.5-1.2-' +
          '1.7c-1.2-0.4-2.3-0.6-3.5-0.7c-1-0.1-2-0.2-2.9-0.5c-1.6,0.7-2.4,1.6-2.4,2.9c0,1.7,1.7,2.6,5.1,' +
          '2.6C268.5,107.3,269.8,107.1,271,106.6z M270.4,91.7c0.8-0.6,1.3-1.6,1.2-2.6c0-2.3-1.4-3.5-4.3-3.' +
          '5c-2.8,0-4.3,1.2-4.3,3.5s1.4,3.4,4.3,3.4C268.4,92.5,269.5,92.2,270.4,91.7L270.4,91.7z'}
          fill={fillColor}
        />
        <path d={'M281.5,100c-1.4-1.5-2.1-3.9-2.1-7.1s0.7-5.6,2.1-7.2c1.6-1.7,3.9-2.6,6.2-2.5c2.1-0.1' +
          ',4.2,0.7,5.5,2.4 c1.2,1.6,1.9,3.9,1.9,7c-0.1,0.3-0.2,0.6-0.4,0.9c-0.3,0.4-0.5,0.6-0.8' +
          ',0.6h-11.3c0,1.6,0.5,3.1,1.5,4.4c1.1,1,2.5,1.5,4,1.4 c0.9,0,1.8-0.1,2.6-0.4c0.6-0.2,1.2-0.5' +
          ',1.8-0.8c0.3-0.2,0.5-0.3,0.8-0.4c0.2,0,0.5,0.2,0.8,0.7c0.2,0.3,0.4,0.7,0.4,1.1 c0,0.3-0.3,0.' +
          '6-0.9,1c-0.7,0.4-1.5,0.7-2.4,0.9c-1,0.3-2.1,0.4-3.2,0.4C285.1,102.3,282.9,101.5,281.5,100z' +
          'M291.8,91.4 c0-3.8-1.4-5.7-4.3-5.7c-3.1,0-4.7,1.9-5,5.7H291.8z'}
          fill={fillColor}
        />
        <path d={'M301.9,101.2c-0.9-0.7-1.4-2-1.4-3.8V85.9h-1.8c-0.2,0-0.4-0.1-0.5-0.3c-0.1-0.3-0.2-0' +
          '.5-0.2-0.8v-0.4 c0-0.3, 0-0.6,0.2-0.8c0.1-0.2,0.3-0.3,0.5-0.3h1.8l0.4-3.8c0.1-0.5,0.5-0.8,1' +
          '.1-0.8h0.4c0.7,0,1.1,0.3,1.1,0.8v3.8h3 c0.2,0, 0.4,0.1,0.6,0.3c0.1,0.3,0.2,0.5,0.2,0.8v0.4c0,0.3,0' +
          ',0.6-0.2,0.8c-0.1,0.2-0.3,0.3-0.6,0.3h-3V97c-0.1,0.7,0.1,1.5, 0.5,2.1 c0.4,0.4,0.9,0.6,1.4,0.' +
          '6c0.3,0,0.7,0,1-0.1c0.2,0,0.3-0.1,0.5-0.1s0.4,0.2,0.5,0.7c0.1,0.3,0.2,0.7,0.2,1c0,' +
          '0.7-0.9,1.1-2.6,1.1 C303.9,102.3,302.8,101.9,301.9,101.2z'}
          fill={fillColor}
        />
        <path d={'M321.3,101.4V85.9h-1.4c-0.2,0-0.4-0.1-0.5-0.3c-0.1-0.3-0.2-0.5-0.2-0.8v' +
          '-0.4c0-0.3,0-0.6,0.2-0.8 c0.1-0.2,0.3-0.3,0.5-0.3h1.4V80c0-1.9,0.5-3.2,1.4-3.9c0' +
          '.9-0.7,2.1-1.1,3.2-1.1c1.7,0,2.6,0.4,2.6,1.1c0,0.3-0.1,0.7-0.2,1 c-0.1,0.4-0.3,0' +
          '.7-0.5,0.7s-0.4,0-0.5-0.1c-0.3-0.1-0.7-0.1-1-0.1c-0.5,0-1,0.2-1.4,0.5c-0.4,0.6-0' +
          '.6,1.4-0.5,2.1v3.1h3.1 c0.2,0,0.4,0.1,0.6,0.3c0.1,0.3,0.2,0.5,0.2,0.8v0.4c0,0.3,' +
          '0,0.6-0.2,0.8c-0.1,0.2-0.3,0.3-0.6,0.3h-3.1v15.4c0,0.5-0.5,0.8-1.4,0.8 h-0.1C321' +
          '.8,102.2,321.3,101.9,321.3,101.4z'}
          fill={fillColor}
        />
        <path d={'M333.2,99.9c-1.4-1.6-2.1-4-2.1-7c0-3.1,0.7-5.5,2.1-7.2c1.6-1.7,3.8-2.6,' +
          '6.2-2.5c2.3-0.1,4.5,0.8,6,2.5 c1.4,1.7,2.1,4,2.1,7.2c0,3.1-0.7,5.5-2.1,7.1c-1.5,' +
          '1.7-3.8,2.6-6.1,2.4C337,102.4,334.7,101.6,333.2,99.9z M343.1,98 c1-1.6,1.4-3.4,1' +
          '.3-5.3c0.1-1.9-0.3-3.7-1.3-5.3c-0.9-1.2-2.4-1.8-3.9-1.7c-1.5-0.1-2.9,0.5-3.8,1.7' +
          'c-0.9,1.6-1.4,3.5-1.2,5.3 c-0.1,1.8,0.3,3.7,1.2,5.3c0.9,1.2,2.3,1.8,3.8,1.7C340.' +
          '7,99.8,342.2,99.2,343.1,98z M335.2,79.6v-1.8c0-0.5,0.5-0.8,1.6-0.8 c1,0,1.4,0.3,' +
          '1.4,0.8v1.8c0,0.5-0.5,0.8-1.6,0.8C335.7,80.4,335.2,80.1,335.2,79.6zM340.3,79.6v' +
          '-1.8c0-0.5,0.5-0.8,1.6-0.8 c1,0,1.4,0.3,1.4,0.8v1.8c0,0.5-0.5,0.8-1.6,0.8C340.8,' +
          '80.4,340.3,80.1,340.3,79.6L340.3,79.6z'}
          fill={fillColor}
        />
        <path d={'M352.6,101.4V88.8c0-1.1,0-2.3-0.2-3.4c-0.1-0.7-0.2-1.1-0.2-1.1c0-0.3,0.' +
          '2-0.5,0.7-0.6 c0.4-0.1,0.8-0.2,1.3-0.2c0.3,0,0.6,0.2,0.7,0.5c0.2,0.4,0.3,0.7,0.4' +
          ',1.1s0.1,0.6,0.2,0.8c1.3-1.8,2.6-2.7,4.1-2.7 c0.5,0,1.1,0.1,1.5,0.4c0.3,0.2,0.5,' +
          '0.6,0.5,1s-0.1,0.9-0.2,1.3s-0.3,0.7-0.5,0.7s-0.5-0.1-0.7-0.2c-0.4-0.1-0.8-0.2-1.' +
          '3-0.2 c-0.6,0-1.1,0.2-1.6,0.5s-0.9,0.6-1.2,1.1c-0.2,0.2-0.4,0.4-0.5,0.6v13.1c0,0' +
          '.5-0.5,0.8-1.4,0.8h-0.1 C353.1,102.2,352.6,101.9,352.6,101.4z'}
          fill={fillColor}
        />
        <path d={'M366.6,100c-1.4-1.5-2.1-3.9-2.1-7.1s0.7-5.6,2.1-7.2c1.6-1.7,3.9-2.6,6.2' +
          '-2.5c2.1-0.1,4.2,0.7,5.5,2.4 c1.2,1.6,1.9,3.9,1.9,7c-0.1,0.3-0.2,0.6-0.4,0.9c-0.' +
          '3,0.4-0.5,0.6-0.8,0.6h-11.3c0,1.6,0.5,3.1,1.5,4.4c1.1,1,2.5,1.5,4,1.4 c0.9,0,1.8' +
          '-0.1,2.6-0.4c0.6-0.2,1.2-0.5,1.8-0.8c0.3-0.2,0.5-0.3,0.8-0.4c0.2,0,0.5,0.2,0.8,0' +
          '.7c0.2,0.3,0.4,0.7,0.4,1.1 c0,0.3-0.3,0.6-0.9,1c-0.7,0.4-1.5,0.7-2.4,0.9c-1,0.3-' +
          '2.1,0.4-3.2,0.4C370.3,102.3,368,101.5,366.6,100z M377,91.4 c0-3.8-1.4-5.7-4.3-5.' +
          '7c-3.1,0-4.7,1.9-5,5.7H377z'}
          fill={fillColor}
        />
        <path d={'M387,101.2c-0.9-0.7-1.4-2-1.4-3.8V85.9h-1.8c-0.2,' +
          '0-0.4-0.1-0.5-0.3c-0.1-0.3-0.2-0.5-0.2-0.8v-0.4c0-0.3,0-0.6,' +
          '0.2-0.8c0.1-0.2,0.3-0.3,0.5-0.3h1.8l0.4-3.8c0.1-0.5,0.5-0.8,' +
          '1.1-0.8h0.4c0.7,0,1.1,0.3,1.1,0.8v3.8h3c0.2,0,0.4,0.1,0.6,0.3c0.1,' +
          '0.3,0.2,0.5,0.2,0.8v0.4c0,0.3,0,0.6-0.2,0.8c-0.1,0.2-0.3,0.3-0.6,' +
          '0.3h-3V97c-0.1,0.7,0.1,1.5,0.5,2.1c0.4,0.4,0.9,0.6,1.4,0.6c0.3,0,0.7,' +
          '0,1-0.1c0.2,0,0.3-0.1,0.5-0.1s0.4,0.2,0.5,0.7c0.1,0.3,0.2,0.7,0.2,1c0,' +
          '0.7-0.9,1.1-2.6,1.1C389.1,102.3,387.9,101.9,387,101.2z'}
          fill={fillColor}
        />
        <path d={'M397.4,100.9c-1.2-1-1.8-2.5-1.7-4c-0.1-1.6,0.5-3.2,1.7-4.2s2.6-1.6,4.2-' +
          '1.8c2-0.3,4-0.4,6-0.4v-1.7c0-0.8-0.3-1.6-0.9-2.2c-0.9-0.6-1.9-0.9-3-0.8c-0.9,0-' +
          '1.9,0.1-2.8,0.4c-0.7,0.2-1.3,0.5-2,0.8c-0.3,0.1-0.6,0.3-0.9,0.4 c-0.2,0-0.5-0.2-' +
          '0.8-0.7c-0.2-0.3-0.4-0.7-0.4-1.1c0-0.3,0.3-0.6,0.9-1c0.8-0.4,1.6-0.7,2.5-0.9c1.1' +
          '-0.3,2.2-0.4,3.3-0.4 c1.8-0.1,3.7,0.4,5.2,1.5c1.2,1,1.9,2.5,1.9,4.1v8c0,1.1,0,2.' +
          '3,0.2,3.4c0.1,0.7,0.2,1.1,0.2,1.1c0,0.3-0.2,0.5-0.7,0.6 c-0.4,0.1-0.8,0.2-1.3,0.' +
          '2c-0.3,0-0.6-0.2-0.7-0.6c-0.2-0.4-0.3-0.8-0.4-1.2c-0.1-0.4-0.1-0.7-0.2-0.8c-1.5,' +
          '1.7-3.7,2.7-6,2.7 C400.3,102.4,398.7,101.9,397.4,100.9z M405,99c0.9-0.5,1.8-1.1,' +
          '2.6-1.8V93c-1.8,0-3.2,0.1-4.4,0.2c-1.1,0.1-2.1,0.4-3,1c-0.9,0.5-1.4,1.5-1.3,2.5' +
          'c-0.1,0.8,0.2,1.6,0.8,2.2c0.6,0.5,1.4,0.8,2.3,0.8C403.1,99.7,404.1,99.5,405,99L4' +
          '05,99z'}
          fill={fillColor}
        />
        <path d={'M417.1,108.6c-1.3-0.6-2.1-1.9-2-3.4c0-1,0.3-1.9,0.9-2.7c0.6-0.8,1.4-1.4' +
          ',2.4-1.8v-0.1 c-0.9-0.7-1.5-1.8-1.4-2.9c0-1.5,0.7-2.9,2-3.7c-0.9-0.5-1.7-1.2-2.3' +
          '-2.1c-0.5-0.9-0.8-1.9-0.8-3c0-1.6,0.6-3.1,1.9-4.2 c1.5-1.2,3.3-1.8,5.2-1.6c0.7,0' +
          ',1.4,0.1,2.1,0.2h6.5c0.2,0,0.4,0.1,0.6,0.3c0.1,0.3,0.2,0.5,0.2,0.8v0.4c0,0.3,0,0' +
          '.6-0.2,0.8 c-0.1,0.2-0.3,0.3-0.6,0.3c-0.8,0-1.7,0-2.5-0.1v0.1c0.6,0.9,1,2,0.9,3.' +
          '1c0,1.6-0.6,3.2-1.8,4.2c-1.5,1.2-3.3,1.8-5.2,1.6 c-0.9-0.1-1.8,0.1-2.5,0.6c-0.6,' +
          '0.4-0.9,1.1-0.9,1.9c0,0.5,0.2,1.1,0.6,1.4s0.9,0.6,1.5,0.7c0.8,0.2,1.7,0.3,2.5,0.' +
          '4 c0.5,0,0.9,0.1,1.2,0.1c1.4,0.1,2.8,0.5,4,1.2c1,0.7,1.5,1.9,1.4,3.1c0.1,1.6-0.7' +
          ',3.1-2.1,4c-1.8,1-4,1.5-6.1,1.4 C420.7,109.8,418.8,109.4,417.1,108.6z M426.6,106' +
          '.6c0.8-0.4,1.2-1.2,1.2-2s-0.4-1.5-1.2-1.7c-1.2-0.4-2.3-0.6-3.5-0.7 c-1-0.1-2-0.2' +
          '-2.9-0.5c-1.6,0.7-2.4,1.6-2.4,2.9c0,1.7,1.7,2.6,5.1,2.6C424.2,107.3,425.5,107.1,' +
          '426.6,106.6z M426.1,91.7 c0.8-0.6,1.3-1.6,1.2-2.6c0-2.3-1.4-3.5-4.3-3.5c-2.8,0-4' +
          '.3,1.2-4.3,3.5s1.4,3.4,4.3,3.4C424,92.5,425.1,92.2,426.1,91.7L426.1,91.7z'}
          fill={fillColor}
        />
        <path d='M70.5,57.8V25.4h19.8v5.3H76.7v8.1h10.7V44H76.7v13.8H70.5z'
          fill={fillColor}
        />
        <path d={'M112.5,44.8l8.3,12.9h-7.6l-6.8-11.2c-1.4,0.2-2.9,0.2-4.3,0v11.1h-6.2V25' +
          '.7c15.3-2.6,22.4,2.1,22.4,10 C118.2,39.6,115.9,43.1,112.5,44.8z M102.1,41.3c6.8,' +
          '0.7,9.7-1.8,9.7-5.6c0-3.5-3.1-5.8-9.7-4.8V41.3z'}
          fill={fillColor}
        />
        <path d='M125.7,25.4h6.2v32.4h-6.2V25.4z'
          fill={fillColor}
        />
        <path d='M159,57.8h-19.5V25.4h6.2v27.1H159V57.8z'
          fill={fillColor}
        />
        <path d={'M162.1,57.8l15-32.7h2.2l14.9,32.7h-6.9l-2.4-5.3h-13.4l-2.4,5.3H162.1z' +
          'M173.7,47.3h8.9l-4.4-10.4L173.7,47.3z'}
          fill={fillColor}
        />
        <path d='M225.2,25.4v32.4l-1.4,0.4l-19.5-19.7v19.2h-6.1V25.4l1.4-0.4L219,44.6V25.4H225.2z'
          fill={fillColor}
        />
        <path d={'M250,32.6c-2.2-1.3-4.7-2-7.3-2.2c-3.1,0-5.3,1.4-5.3,3.5c0,2.3,2.6,3.6,6' +
          '.2,4.9c7.5,2.9,9.7,6.4,9.5,10.4 c-0.1,5.8-5.3,9.2-11.7,9.1c-3.9-0.1-7.7-1.3-10.8' +
          '-3.7l2.3-4.8c2.3,1.8,5.1,2.8,8.1,2.9c2.9,0,5.9-1.1,5.9-3.5 c0-2.7-3.7-3.9-7.6-5.' +
          '6c-5-2.3-8.2-5.1-8.2-9.9c0-4.6,3.9-9.2,11.1-9.2c3.4,0.2,6.8,1.1,9.8,2.6L250,32.6z'}
          fill={fillColor}
        />
        <path d='M270.6,57.8V25.4h19.8v5.3h-13.6v8.1h10.7V44h-10.7v13.8H270.6z'
          fill={fillColor} />
        <path d='M296.4,25.4h6.2v32.4h-6.2V25.4z'
          fill={fillColor} />
        <path d='M337.5,25.4v32.4l-1.4,0.4l-19.5-19.7v19.2h-6.1V25.4l1.4-0.4l19.5,19.7V25.4H337.5z'
          fill={fillColor}
        />
        <path d={'M340.6,57.8l15-32.7h2.2l14.9,32.7h-6.9l-2.4-5.3H350l-2.4,5.3H340.6z M352.2,47.3h8.' +
          '9l-4.4-10.4L352.2,47.3z'}
          fill={fillColor}
        />
        <path d='M403.8,25.4v32.4l-1.4,0.4l-19.5-19.7v19.2h-6.1V25.4l1.4-0.4l19.5,19.7V25.4H403.8z'
          fill={fillColor}
        />
        <path d={'M429.2,32.6c-2.2-1.3-4.7-2-7.3-2.2c-3.1,0-5.3,1.4-5.3,3.5c0,2.3,2.6,3.6' +
          ',6.2,4.9c7.5,2.9,9.7,6.4,9.5,10.4 c-0.1,5.8-5.3,9.2-11.7,9.1c-3.9-0.1-7.7-1.3-10' +
          '.8-3.7l2.3-4.8c2.3,1.8,5.1,2.8,8.1,2.9c2.9,0,5.9-1.1,5.9-3.5 c0-2.7-3.7-3.9-7.6-' +
          '5.6c-5-2.3-8.2-5.1-8.2-9.9c0-4.6,3.9-9.2,11.1-9.2c3.4,0.2,6.8,1.1,9.8,2.6L429.2,32.6z'}
          fill={fillColor}
        />
        <path d={'M26.2,58h-25C0,58,0,58,0,56.8c0-0.1,0-0.3,0-0.4c0-0.4,0.1-0.5,0.5-0.6c1' +
          '.5-0.1,4.1-0.7,5.2-1.6 c2.2-2.1,5.7-2.1,7.9,0c2.4,2.1,6,2.2,8.5,0.1c2.8-2.3,5.5-' +
          '2.3,8.3,0c2.4,2,6,2,8.4,0c2.7-2.3,5.4-2.3,8.1,0 c1.1,0.9,3.7,1.5,5.2,1.5c0.4,0,0' +
          '.5,0.2,0.5,0.5c0,1.7-1.4,1.7-3.1,1.7H26.2z'}
          fill={fillColor}
        />
        <path d={'M52.6,53.3c0,0.6-0.2,0.8-0.7,0.6c-0.1,0-1.7-0.1-1.8-0.1c-1.5-0.3-1.6-0.' +
          '4-1.6-1.8c0-14.1,0-6,0-20.1 c0.1-1.9-1.1-3.7-2.9-4.2c-2.2-0.8-' +
          '4.6,0.3-5.4,2.5c-0.1,0.4-0.2,0.8-0.3,1.2c0,13.8,0,5.5,0,19.3c0,0.5-0.2,1-0.7,1.3' +
          'c-1.1,1-2.4,1.7-3.8,2c-1.6,0.2-3.1-0.2-4.3-1.2c-0.3-0.2-0.4-0.6-0.4-0.9c0-1.4,0' +
          '-2.8,0-4.2c0-13.7,0-5.3,0-19 c0.1-0.9-0.2-1.9-0.6-2.7c-1-1.5-2.8-2.3-4.6-1.9c-1.' +
          '7,0.3-3.1,1.7-3.4,3.5c-0.1,0.5-0.1,1-0.1,1.5c0,13.4,0,4.7,0,18.1 c0,1.5,0,3,0,4.' +
          '5c0,0.5-0.3,1-0.7,1.3c-2,1.3-4.6,1.3-6.5,0c-0.6-0.4-1.1-0.9-1.6-1.3c-0.2-0.1-0.3' +
          '-0.4-0.3-0.6 c0-0.8-0.1-1.7-0.1-2.5c0-13,0-4,0-17c0-2-1.5-3.7-3.4-4c-2.1-0.4-4.2' +
          ',0.8-4.9,2.8c-0.1,0.5-0.2,1-0.2,1.5c0,12.7,0,3.2,0,15.9 c0,1.6-0.1,3.2,0,4.8c0.1' +
          ',0.6-0.3,1.1-0.8,1.2l0,0c-0.1,0-0.2,0-0.2,0.1c-1.7,0.5-3,0.4-3-1c0-16.6,0-10.5,0' +
          '-27.1 c0-0.8,0.2-1.1,1-1.3c7.8-2.4,16.9-5.4,24.6-7.8c0.4-0.1,0.8-0.1,1.2,0c7.8,2' +
          '.4,17,5.5,24.8,7.9c0.6,0.2,0.9,0.5,0.9,1.1 C52.6,32.9,52.6,51,52.6,53.3'}
          fill={fillColor}
        />
        <path d={'M9.7,13.1c0,0.6,0,1.2,0,1.8c0,0.4,0.1,0.5,0.5,0.5c1,0,2.1,0,3.1,0c0.3,0' +
          ',0.6,0,0.6-0.4c0-1.3,0.1-2.5-0.1-3.8 c-0.2-1.1-1.2-1.9-2.3-1.7c0,0,0,0-0.1,0c-1.' +
          '1,0.1-1.8,1-1.8,2C9.7,12.1,9.7,12.6,9.7,13.1 M6.2,20.5v-4.4c0-2.8,0-5.5,0-8.3 C6' +
          '.2,7.2,6.4,7,7,7.1c3.2,0,6.4,0,9.6,0c0.6,0,0.8,0.1,0.8,0.7c0,2.9,0,5.8,0,8.6c0.1' +
          ',0.4-0.2,0.7-0.5,0.8l0,0 c-3.4,1-6.7,2.1-10.1,3.1C6.5,20.4,6.4,20.4,6.2,20.5'}
          fill={fillColor}
        />
        <path d={'M40,5.5c1.9,0,3.9,0,5.8,0c0.6,0,0.8-0.1,0.8-0.7c0-1.3,0-2.9,0-4.2c0-0.4' +
          '-0.1-0.4-1.5-0.4 c-1.3,0-1.4,0.1-1.4,0.6v1.7c0,0.4-0.1,0.4-1.2,0.4c-1.1,0-1.2-0.' +
          '1-1.2-0.4c0-0.4,0-0.9,0-1.6s0-0.7-1.4-0.7c-1.6,0-1.4,0-1.4,1.1 c0,0.4,0,1.1,0,1.' +
          '2c0,0.4-0.3,0.3-1.2,0.3s-1.1,0-1.1-0.3c0-0.5,0-1.3,0-1.8c0-0.4,0-0.6-1.3-0.6c-1.' +
          '5,0-1.5,0-1.5,0.6 c0,0.8,0,3.2,0,4c0,0.6,0.2,0.9,0.9,0.8C36.2,5.4,38.1,5.5,40,5.5'}
          fill={fillColor}
        />
        <path d={'M11.8,5.5c1.9,0,3.9,0,5.8,0c0.6,0,0.8-0.1,0.8-0.7c0-1.3,0-2.9,0-4.2c0-0' +
          '.4-0.1-0.4-1.5-0.4 c-1.3,0-1.4,0.1-1.4,0.6v1.7c0,0.4-0.5,0.4-1.2,0.4c-0.8,0-1.2-' +
          '0.1-1.2-0.4c0-0.4,0-0.9,0-1.6s0-0.7-1.4-0.7c-1.6,0-1.4,0-1.4,1.1 c0,0.4,0,1.1,0,' +
          '1.2c0,0.4-0.5,0.3-1.2,0.3S8,2.8,8,2.5C8,2,8,1.2,8,0.7c0-0.4,0-0.6-1.3-0.6C5.2,0,' +
          '5.2,0,5.2,0.6c0,0.8,0,3.2,0,4 c0,0.6,0.2,0.9,0.9,0.8C8,5.4,9.9,5.5,11.8,5.5'}
          fill={fillColor}
        />
        <path d={'M42,13.1c0,0.6,0,1.2,0,1.8c0,0.4-0.1,0.5-0.5,0.5c-1,0-2.1,0-3.1,0c-0.3,' +
          '0-0.6,0-0.6-0.4 c0-1.3-0.1-2.5,0.1-3.8c0.2-1.1,1.2-1.9,2.3-1.7c0,0,0,0,0.1,0c1,0' +
          '.1,1.8,1,1.8,2C42,12.1,42,12.6,42,13.1 M45.6,20.5v-4.4 c0-2.8,0-5.5,0-8.3c0-0.6-' +
          '0.2-0.8-0.8-0.7c-3.2,0-6.4,0-9.5,0c-0.6,0-0.8,0.1-0.8,0.7c0,2.9,0,5.8,0,8.6c-0.1' +
          ',0.4,0.2,0.7,0.5,0.8 l0,0c3.3,1,6.7,2.1,10,3.1C45.2,20.4,45.4,20.4,45.6,20.5'}
          fill={fillColor}
        />

      </svg>
    );
  }
}

export default LogoInvoiceWithoutCompany;



/** WEBPACK FOOTER **
 ** ./src/components/svg/logo-invoice-without-company.js
 **/